import { render, staticRenderFns } from "./ServiceRightList.vue?vue&type=template&id=cfef030a"
import script from "./ServiceRightList.vue?vue&type=script&lang=js"
export * from "./ServiceRightList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports